// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IPageableObject } from './IPageableObject';
import {
    IPageableObjectFromJSON,
    IPageableObjectFromJSONTyped,
    IPageableObjectToJSON,
    IPageableObjectToJSONTyped,
} from './IPageableObject';
import type { ISortOrder } from './ISortOrder';
import {
    ISortOrderFromJSON,
    ISortOrderFromJSONTyped,
    ISortOrderToJSON,
    ISortOrderToJSONTyped,
} from './ISortOrder';
import type { ICardActivityDto } from './ICardActivityDto';
import {
    ICardActivityDtoFromJSON,
    ICardActivityDtoFromJSONTyped,
    ICardActivityDtoToJSON,
    ICardActivityDtoToJSONTyped,
} from './ICardActivityDto';

/**
 * 
 * @export
 * @interface IPageCardActivityDto
 */
export interface IPageCardActivityDto {
    /**
     * 
     * @type {number}
     * @memberof IPageCardActivityDto
     */
    total_pages?: number;
    /**
     * 
     * @type {number}
     * @memberof IPageCardActivityDto
     */
    total_elements?: number;
    /**
     * 
     * @type {number}
     * @memberof IPageCardActivityDto
     */
    size?: number;
    /**
     * 
     * @type {Array<ICardActivityDto>}
     * @memberof IPageCardActivityDto
     */
    content?: Array<ICardActivityDto>;
    /**
     * 
     * @type {number}
     * @memberof IPageCardActivityDto
     */
    number?: number;
    /**
     * 
     * @type {Array<ISortOrder>}
     * @memberof IPageCardActivityDto
     */
    sort?: Array<ISortOrder>;
    /**
     * 
     * @type {IPageableObject}
     * @memberof IPageCardActivityDto
     */
    pageable?: IPageableObject;
    /**
     * 
     * @type {number}
     * @memberof IPageCardActivityDto
     */
    number_of_elements?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IPageCardActivityDto
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPageCardActivityDto
     */
    last?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPageCardActivityDto
     */
    empty?: boolean;
}

/**
 * Check if a given object implements the IPageCardActivityDto interface.
 */
export function instanceOfIPageCardActivityDto(value: object): value is IPageCardActivityDto {
    return true;
}

export function IPageCardActivityDtoFromJSON(json: any): IPageCardActivityDto {
    return IPageCardActivityDtoFromJSONTyped(json, false);
}

export function IPageCardActivityDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPageCardActivityDto {
    if (json == null) {
        return json;
    }
    return {
        
        'total_pages': json['totalPages'] == null ? undefined : json['totalPages'],
        'total_elements': json['totalElements'] == null ? undefined : json['totalElements'],
        'size': json['size'] == null ? undefined : json['size'],
        'content': json['content'] == null ? undefined : ((json['content'] as Array<any>).map(ICardActivityDtoFromJSON)),
        'number': json['number'] == null ? undefined : json['number'],
        'sort': json['sort'] == null ? undefined : ((json['sort'] as Array<any>).map(ISortOrderFromJSON)),
        'pageable': json['pageable'] == null ? undefined : IPageableObjectFromJSON(json['pageable']),
        'number_of_elements': json['numberOfElements'] == null ? undefined : json['numberOfElements'],
        'first': json['first'] == null ? undefined : json['first'],
        'last': json['last'] == null ? undefined : json['last'],
        'empty': json['empty'] == null ? undefined : json['empty'],
    };
}

export function IPageCardActivityDtoToJSON(json: any): IPageCardActivityDto {
    return IPageCardActivityDtoToJSONTyped(json, false);
}

export function IPageCardActivityDtoToJSONTyped(value?: IPageCardActivityDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalPages': value['total_pages'],
        'totalElements': value['total_elements'],
        'size': value['size'],
        'content': value['content'] == null ? undefined : ((value['content'] as Array<any>).map(ICardActivityDtoToJSON)),
        'number': value['number'],
        'sort': value['sort'] == null ? undefined : ((value['sort'] as Array<any>).map(ISortOrderToJSON)),
        'pageable': IPageableObjectToJSON(value['pageable']),
        'numberOfElements': value['number_of_elements'],
        'first': value['first'],
        'last': value['last'],
        'empty': value['empty'],
    };
}

